<template>
    <div v-if="body_show">
        <div class="task-box task2" v-if="show_new_task">
            <div class="task-title">
                {{ title }}
            </div>
            <div v-for="(item, index) in dynamicData" :class="[item.type === 'select2' ? 'in-block' : '', 'task-box task2 task-plr-reset']">
                <!-- fill -->
                <div v-if="item.type === 'fill'" class="task_f">
                    <h3 class="label">{{ item.label }}</h3>
                    <div class="clearfix">
                        <div v-if="item.yield" v-for="item2 in item.list" class="task_ninput pull-left">
                            <span v-if="!item2.attr">{{item2.label}}</span>
                            <input v-if="item2.attr" v-model="item2.value" type="text" class="task_n" />
                            <span v-if="item2.attr">{{item2.label}}</span>
                        </div>
                    </div>
                </div>
                <!-- title -->
                <div v-if="item.type === 'title'" class="task_f">
                    <h3 class="label">{{ item.label }}<span v-if="item.config">{{item.config.subtitle.text}}</span></h3>
                </div>
                <!-- tip -->
                <div v-if="item.type === 'tips'" class="task_f">
                    <h3 class="label">{{item.label}}
                        <span v-for="item2 in item.list" @click="showTagModul(item2.tip, item2.lab, item2.val)" :class="item2.tip ? 'noun' : ''">{{item2.tip ? item2.lab : item2}}</span>
                    </h3>
                </div>
                <!-- select1 -->
                <div v-if="item.type === 'select1'" class="cell project4-task-row clearfix">
                    <div v-for="item2 in item.list" class="pull-left">
                        <van-cell-group v-if="item2.attr" class="grouping project3-task1 pull-left clearfix">
                            <van-field v-model="item2.value" @click="showPicker(item2.select, item2)" readonly />
                            <label class="choose_lable"></label>
                        </van-cell-group>
                        <span v-if="item2.attr" class="pull-left">{{item2.label}}</span>
                        <span v-else class="pull-left">{{item2.label}}</span>
                    </div>
                </div>
                <!-- select2 -->
                <div v-if="item.type === 'select2'" class="cell project4-task-row clearfix">
                    <span class="pull-left">{{item.label}}</span>
                    <van-cell-group class="grouping project3-task1 mt-reset pull-left clearfix">
                        <van-field v-model="item.value" @click="showPicker(item.select, item)" readonly />
                        <label class="choose_lable"></label>
                    </van-cell-group>
                </div>
                <!-- textarea -->
                <div v-if="item.type === 'textarea'" class="cell clearfix">
                    <div class="task_f mt-reset clearfix">
                        <h3 class="label task_pb10">{{item.label}}<span v-if="item.tips">{{item.tips}}</span></h3>
                        <div class="input-mt mt-reset">
                            <textarea v-model="item.value" @input="changeVal($event, item, item.config.length)" :placeholder="item.config.tips"></textarea>
                        </div>
                        <span class="float">{{item.value.length}}/{{item.config.length}}</span>
                    </div>
                </div>
            </div>
            <div class="submitBtn">
                <van-button @click="dynDataSub"  :class="verification() ? 'actice' : ''">提交</van-button>
            </div>
            <!-- 选择 -->
            <van-popup v-model="picker_show" position="bottom">
                <van-picker show-toolbar :columns="selectList" @cancel="picker_show = false" @confirm="confirm" />
            </van-popup>
            <!-- 弹出标签 -->
            <van-popup class="explain" v-model="tagModul">
                <div>
                    <h2>{{ tagModulData.title }}</h2>
                    <div class="pps" v-html="tagModulData.content"></div>
                </div>
            </van-popup>
        </div>
        <div v-else class="task-box task2">
            <div class="task-title">
    			{{ title }}
    		</div>
            <!-- 下一步行动 -->
            <div class="task_f">
                <h3 class="label">请填写：课程结束7天内，我的下⼀步⾏动是</h3>
                <div class="input-box input-mt">
                    <div>
                        <input v-model="action_one" type="text" placeholder="请简要描述你的具体行动" />
                    </div>
                </div>
                <span class="float">{{action_one.length}}/57</span>
            </div>
            <!-- 我如何知道这个⾏动是成功的？ -->
            <div class="task_f mt-m">
    			<h3 class="label">我如何知道这个⾏动是成功的？</h3>
    			<div class="input-mt">
    				<textarea  v-model="action_one_norm" placeholder="达到什么状态，这个行动就算成功了？"></textarea>
    			</div>
    			<span class="float">{{action_one_norm.length}}/150</span>
    		</div>
            <!-- 下一步行动 -->
            <div class="task_f">
                <h3 class="label">请填写：课程结束7天内，我的下⼀步⾏动是</h3>
                <div class="input-box input-mt">
                    <div>
                        <input v-model="action_two" type="text" placeholder="请简要描述你的具体行动" />
                    </div>
                </div>
                <span class="float">{{action_two.length}}/57</span>
            </div>
            <!-- 我如何知道这个⾏动是成功的？ -->
            <div class="task_f mt-m">
    			<h3 class="label">我如何知道这个⾏动是成功的？</h3>
    			<div class="input-mt">
    				<textarea  v-model="action_two_norm" placeholder="达到什么状态，这个行动就算成功了？"></textarea>
    			</div>
    			<span class="float">{{action_two_norm.length}}/150</span>
    		</div>
            <!-- 下一步行动 -->
            <div class="task_f">
                <h3 class="label">请填写：课程结束7天内，我的下⼀步⾏动是</h3>
                <div class="input-box input-mt">
                    <div>
                        <input v-model="action_three" type="text" placeholder="请简要描述你的具体行动" />
                    </div>
                </div>
                <span class="float">{{action_three.length}}/57</span>
            </div>
            <!-- 我如何知道这个⾏动是成功的？ -->
            <div class="task_f mt-m">
    			<h3 class="label">我如何知道这个⾏动是成功的？</h3>
    			<div class="input-mt">
    				<textarea  v-model="action_three_norm" placeholder="达到什么状态，这个行动就算成功了？"></textarea>
    			</div>
    			<span class="float">{{action_three_norm.length}}/150</span>
    		</div>
            <!-- 提交 -->
            <div class="submitBtn">
                <van-button v-if="validationHandle()" @click="submitHandle"  class="actice" >提交</van-button>
                <van-button v-else  >提交</van-button>
            </div>
        </div>
    </div>
</template>

<script>
import { getStorage, setStorage, isMain } from "@/utils/tools"
import { get_selfstock_data,update_selfstock_data, index, subtable } from "@/api/course"
import { shareCon } from "@/utils/wxconfig";
export default {
    data(){
        return{
            body_show:false,
            title:'T3：下一步行动',
            action_one:'',
            action_one_norm:'',
            action_two:'',
            action_two_norm:'',
            action_three:'',
            action_three_norm:'',
            objArg: {
                cid: "",
                cpid: ""
            },
            //
            dynamicData: [],
            form_id: '',
            tagModul: false,
            picker_show: false,
            tagModulData: {
                title: "默认标题",
                content: "默认标签提示内容"
            },
            selectItem: null,
            backupList: {},
            selectList: []
        }
    },
    computed: {
        show_new_task(){
            let q = this.$route.query;
            if(!isMain()){
                return true
            }
            if(isMain() && (q.cid == 5 || q.cid >= 7)){
                return true
            }
            return false
        }
    },
    methods:{
        changeVal(ev, item, maxLen){
            let tarLen = ev.target.value.length;
            if(tarLen > maxLen){
                item.value = item.value.substring(0, maxLen);
            }
        },
        verification(){
            for(let arg of this.dynamicData){
                if(arg.type === 'fill' || arg.type === 'select1'){
                    for(let arg2 of arg.list){
                        if(arg2.attr && !arg2.value){
                            return
                        }
                    }
                }else if(arg.type === 'select2' || arg.type === 'textarea'){
                    if(!arg.value){
                        return
                    }
                    if(arg.type === 'textarea' && arg.value.length > arg.config.length){
                        return
                    }
                }
            }
            return true
        },
        getDynData(){
            let newData = []
            for(let arg of this.dynamicData){
                if(arg.type === 'fill' || arg.type === 'select1'){
                    let conJson = {};
                    for(let item of arg.list){
                        if(item.attr){
                            conJson[item.attr] = item.value
                        }
                    }
                    newData.push({
                        'field_id': arg.id,
                        'content': JSON.stringify(conJson)
                    })
                }else if(arg.type === 'select2' || arg.type === 'textarea'){
                    newData.push({
                        'field_id': arg.id,
                        'content': arg.value
                    })
                }
            }
            return newData
        },
        dynDataSub(){
            let testResult = this.verification();
            if(!testResult){
                return
            }
            // loading
            this.$toast.loading({
                mask: true,
                message: "加载中..."
            });
            // 成立
            let getData = this.getDynData();
            // console.log(JSON.stringify(getData));
            let q = this.$route.query;
            subtable({
                cid: q.cid,
                type: "taskone",
                cpid: q.pid,
                cptid: q.id,
                form_id: this.form_id,
                field: JSON.stringify(getData)
            })
            .then((data) => {
                let q = this.$route.query;
                this.$toast.clear();
                this.objArg.cid = q.cid;
                this.objArg.cpid = q.pid;
                this.$router.push({path:'/project_report',query:this.objArg});
            })
        },
        confirm(val){
            this.selectItem.value = val;
            this.picker_show = false;
        },
        showPicker(select, item){
            this.picker_show = true;
            this.selectItem = item;
            this.selectList = select;
        },
        showTagModul(bool, title, content){
            if(!bool){
                return
            }
            this.tagModul = true;
            this.tagModulData['title'] = title;
            this.tagModulData['content'] = content;
        },
        pullData(){
            let q = this.$route.query;
            if(this.show_new_task){
                // 新版本
                this.dynamicData = [];
                index({
                    cid: q.cid,
                    cpid: q.pid,
                    cptid: q.id
                })
                .then(data => {
                    this.title = data.title;
                    let isReset = !!data.userfield.length;

                    let userData = data.userfield;
                    let newJSON = {};
                    for(let arg of userData){
                        newJSON[arg.field_id] = arg.content;
                    }

                    // 没有编辑过
                    let list = data.field;
                    this.form_id = list[0].form_id;
                    // 取默认数据
                    for(let [i1, arg] of list.entries()){
                        if(arg.type === 'fill'){
                            // 存key
                            let nk = {};
                            for(let [index, arg2] of arg.config.text.entries()){
                                if(arg2.attr){
                                    arg2.value = '';
                                    nk[arg2.attr] = index;
                                }
                                if(!isReset && arg2.attr){
                                    arg2.value = arg.config.variable[arg2.attr].content;
                                }
                            }
                            let nd = {
                                id: arg.id,
                                type: 'fill',
                                yield: true,
                                label: arg.label,
                                back: nk,
                                list: arg.config.text
                            };
                            if(isReset){
                                let sc = JSON.parse(newJSON[nd.id]);
                                for(let attr in nk){
                                    let index = nk[attr];
                                    let value = sc[attr];
                                    nd.list[index].value = value;
                                }
                            }
                            this.dynamicData.push(nd)
                        }else if(arg.type === 'title'){
                            this.dynamicData.push({
                                id: arg.id,
                                type: 'title',
                                yield: false,
                                config: arg.config,
                                label: arg.label
                            })
                        }else if(arg.type === 'tips'){
                            let j = arg.config.subtitle.difficult;
                            let t = arg.config.subtitle.text;
                            let key;
                            for(let attr in j){
                                key = attr;
                            }
                            let arr = t.split(key);
                            arr[2] = arr[1];
                            arr[1] = {
                                tip: true,
                                lab: key,
                                val: j[key].content.replace(/\n/ig, '<br/>')
                            }
                            this.dynamicData.push({
                                id: arg.id,
                                type: 'tips',
                                yield: true,
                                label: arg.label,
                                list: arr
                            })
                        }else if(arg.type === 'select'){
                            let text = arg.config.text;
                            let json = arg.config.variable;
                            // 多项
                            if(text){
                                let nk = {}
                                for(let [index, arg2] of text.entries()){
                                    if(arg2.attr){
                                        arg2.value = '';
                                        arg2.select = json[arg2.attr].content;
                                        nk[arg2.attr] = index;
                                    }
                                }
                                let nd = {
                                    id: arg.id,
                                    type: 'select1',
                                    yield: true,
                                    back: nk,
                                    list: text
                                }
                                if(isReset){
                                    let sc = JSON.parse(newJSON[nd.id]);
                                    for(let attr in nk){
                                        let index = nk[attr];
                                        let value = sc[attr];
                                        nd.list[index].value = value;
                                    }
                                }
                                this.dynamicData.push(nd)
                            }else{
                                let nd = {
                                    id: arg.id,
                                    type: 'select2',
                                    yield: false,
                                    value: '',
                                    label: arg.label,
                                    select: arg.config.content
                                }
                                if(isReset  && data.userfield[i1]){
                                    nd.value = newJSON[nd.id]
                                }
                                this.dynamicData.push(nd)
                            }
                        }else if(arg.type === 'textarea'){
                            let nd = {
                                id: arg.id,
                                type: 'textarea',
                                yield: false,
                                label: arg.label,
                                tips: arg.config.subtitle ? arg.config.subtitle.text : false,
                                value: '',
                                config: {
                                    tips: arg.config.placeholder,
                                    length: arg.config.word
                                }
                            }
                            if(isReset){
                                nd.value = newJSON[nd.id] || '';
                            }
                            this.dynamicData.push(nd)
                        }
                    }

                    this.body_show = true;
                    // console.log(this.dynamicData);
                })
            }else{
                get_selfstock_data({
                    cid:this.$route.query.cid,
                    type:"taskthree"
                })
                .then(data => {
                    this.body_show = true;
                    let d = data.data;
                    let path =this.$route.path;

                    this.action_one = d.action_one?d.action_one:getStorage(path, 'action_one') || '';
                    this.action_one_norm = d.action_one_norm?d.action_one_norm:getStorage(path, 'action_one_norm') || '';
                    this.action_two = d.action_two?d.action_two:getStorage(path, 'action_two') || '';
                    this.action_two_norm = d.action_two_norm?d.action_two_norm:getStorage(path, 'action_two_norm') || '';
                    this.action_three = d.action_three?d.action_three:getStorage(path, 'action_three') || '';
                    this.action_three_norm = d.action_three_norm?d.action_three_norm:getStorage(path, 'action_three_norm') || '';
                });
            }
        },
        // 非空验证
        validationHandle(){
            let str_fields = [
                'action_one',
                'action_one_norm',
                'action_two',
                'action_two_norm',
                'action_three',
                'action_three_norm'
            ];
            // 循环判断数组内属性内容是为空
            for(let i = 0; i < str_fields.length; i++) {
                if(this.$Validator.isEmpty(this[str_fields[i]])){
                    return false;
                }
            }
            return true;
        },
        // 提交数据
        submitHandle(){
            this.$toast.loading({
                mask: true,
                message: "加载中..."
            });
            update_selfstock_data({
               cid:this.$route.query.cid,
                type:"taskthree",
                cpid: this.$route.query.pid,
                cptid:this.$route.query.id,
                iscreate: 1,
                action_one:this.action_one,
                action_one_norm:this.action_one_norm,
                action_two:this.action_two,
                action_two_norm:this.action_two_norm,
                action_three:this.action_three,
                action_three_norm:this.action_three_norm
            })
            .then(data => {
                this.$toast.clear();
                this.objArg.cid = this.$route.query.cid;
                this.objArg.cpid = this.$route.query.pid;
                this.$router.push({path:'/project_report',query:this.objArg});

            });
        },
        setTitle(){
            let title = this.$route.query.name;
            document.title = decodeURI(title);
        }
    },
    created(){
        this.pullData();
        this.setTitle();
        shareCon("course",this);
    },
    watch:{
        action_one(newVal,oldVal){
            if(newVal.length > 57) {
              this.action_one = newVal.slice(0, 57);
              this.$toast('最多只能输入'+57+'个字。/(ㄒoㄒ)/~~！');
            }else{
                setStorage(this.$route.path, 'action_one', newVal);
            }
        },
        action_one_norm(newVal,oldVal){
            if(newVal.length > 150) {
              this.action_one_norm = newVal.slice(0, 150);
              this.$toast('最多只能输入'+150+'个字。/(ㄒoㄒ)/~~！');
            }else{
                setStorage(this.$route.path, 'action_one_norm', newVal);
            }
        },
        action_two(newVal,oldVal){
            if(newVal.length > 57) {
              this.action_two = newVal.slice(0, 57);
              this.$toast('最多只能输入'+57+'个字。/(ㄒoㄒ)/~~！');
            }else{
                setStorage(this.$route.path, 'action_two', newVal);
            }
        },
        action_two_norm(newVal,oldVal){
            if(newVal.length > 150) {
              this.action_two_norm = newVal.slice(0, 150);
              this.$toast('最多只能输入'+150+'个字。/(ㄒoㄒ)/~~！');
            }else{
                setStorage(this.$route.path, 'action_two_norm', newVal);
            }
        },
        action_three(newVal,oldVal){
            if(newVal.length > 57) {
              this.action_three = newVal.slice(0, 57);
              this.$toast('最多只能输入'+57+'个字。/(ㄒoㄒ)/~~！');
            }else{
                setStorage(this.$route.path, 'action_three', newVal);
            }
        },
        action_three_norm(newVal,oldVal){
            if(newVal.length > 150) {
              this.action_three_norm = newVal.slice(0, 150);
              this.$toast('最多只能输入'+150+'个字。/(ㄒoㄒ)/~~！');
            }else{
                setStorage(this.$route.path, 'action_three_norm', newVal);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "@s/taskStyle.scss";
    .label{
        span{
            font-size: 0.32rem;
            color: #666;
        }
    }
    .task-box.task2{
        .task_f.mt-m{
            margin-top: 30px;
            h3{
                line-height: 1;
            }
        }
    }
    //
    .task-plr-reset{
        padding-left: 0;
        padding-right: 0;
    }
    .task_ninput{
        .task_n{
            width: 60px;
        }
    }
    .mt-reset{
        margin-top: 0!important;
    }
    .in-block{
        display: inline-block;
    }
    .task_pb10{
        padding-bottom: 10px;
    }
    .project4-task-row{
        color: #666;
        word-wrap: break-word;
        word-break: normal;
        span{
            height: 69px;
            line-height: 69px;
            padding: 0 10px;
            display: block;
        }
    }
</style>
<style>
    .project3-task1 .van-cell .van-cell__value input{
        width: 2.5rem;
    }
</style>